// extracted by mini-css-extract-plugin
export default {"text-body-1":"Footer_text-body-1__eyZtk","text-body-3":"Footer_text-body-3__QeusT","footer":"Footer_footer__PxxIj","upDown":"Footer_upDown__DQ36p"};